import styled from 'styled-components';

import {
  Flex,
  SVG,
} from 'web-styled';

const cardElementStyles = `
  display: grid;
  align-items: center;
  padding: 6px 12px;
  font-size: 14px;
  width: 100%;
  height: 38px;
  line-height: 38px;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: inset 0 1px 1px rgba(0,0,0, 0.075);
  color: #333;
`;

export const ExpirationDate = styled(Flex).attrs({
  column: true,
  spacing: 5,
})`
  position: relative;
  .card-element {
    ${cardElementStyles};
    border: ${({ hasError }) => (hasError ? '1px solid #ff560a' : '1px solid #ccc')}
  }

  .error-message {
    display: ${({ hasError }) => (hasError ? '' : 'none')};
    position: absolute;
    width: 180px;
    top: 23px;
    left: 110%;
    color: #ff560a;
    font-size: 13px;
    line-height: 18px;
  }
`;

export const CardNumContainer = styled(Flex).attrs({
  column: true,
  spacing: 5,
})`
  width: 100%;
  position: relative;

  .card-element {
    ${cardElementStyles};
    border: ${({ hasError }) => (hasError ? '1px solid #ff560a' : '1px solid #ccc')}
  }
  .error-message {
    display: ${({ hasError }) => (hasError ? '' : 'none')};
    position: absolute;
    right: 0;
    top: -1px;
    color: #ff560a;
    font-size: 13px;
  }
`;

export const CVVContainer = styled(Flex).attrs({
  grow: 1,
  justify: 'flex-end',
  column: true,
  spacing: 5,
})`
  max-width: 135px;
  position: relative;

  .card-element {
    ${cardElementStyles};
    border: ${({ hasError }) => (hasError ? '1px solid #ff560a' : '1px solid #ccc')}
  }

  .error-message {
    display: ${({ hasError }) => (hasError ? '' : 'none')};
    position: absolute;
    width: 180px;
    bottom: -17px;
    color: #ff560a;
    font-size: 13px;
    line-height: 18px;
  }
`;

export const LockIcon = styled(SVG.Lock).attrs(
  props => ({
    width: '25px',
    height: '25px',
    fill: props.theme.colors.primary,
  }),
)``;

export const AddCardForm = styled(Flex).attrs({
  fillSpace: true,
  column: true,
  justify: 'space-around',
  align: 'center',
  as: 'form',
})`
  min-height: 350px;

  .card-element {
    width: 100%;
  }
`;
